import { logger } from '@origin-digital/reporting-client';
import { getWindow } from 'ts/window/Window';
import * as ConfigService from '../../config/ConfigService';

/**
 * After reset password is completed, get the state from the url and call continue with the state information.
 * The Auth0 rule will then pass the token to the client & redirect to the final destination.
 *
 */
const readStateIfExistsAndRedirect = (auth0State: string, fallbackUrl?: string) => {
  // If state is available, redirect to continue url otherwise redirect to fallbackUrl
  logger.debug('getting state from url');
  if (auth0State) {
    const continueUrl = `https://${ConfigService.getAuth0Domain()}/continue?state=${auth0State}`;
    logger.debug('state found from url param, redirecting to continue url');
    getWindow().location.replace(continueUrl);
  } else {
    // no state found, redirect to fallbackUrl if exists or go to homepage
    logger.warn('no state found, redirecting');
    getWindow().location.replace(fallbackUrl || ConfigService.getHomepageUrl());
  }
};

export { readStateIfExistsAndRedirect };
